<template>
  <div class="container">
    <div class="searchBox">
      <el-form
        ref="searchForm" v-model="queryForm" :inline="false"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <!--创建时间-->
            <el-form-item prop="searchTimeType">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.timeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :style="IsWidthTime"
                  class="selectClass"
                  size="small"
                >
                  <el-option
                    v-for="item in timeTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                size="small"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 岗位 -->
            <el-form-item :label="$t('home.position')">
              <el-select
                v-model="queryForm.params.position"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--转运中心-->
            <el-form-item :label="$t('collectionCenter.transferCenter')">
              <el-select
                v-model="queryForm.params.departmentIds"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in TransferList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--  登记人  -->
            <el-form-item :label="$t('collectionCenter.registrar')">
              <el-select
                v-model="queryForm.params.registrationUser"
                :placeholder="$t('operationCenter.Only10AreDisplayed')"
                :remote-method="getRegistrationUserList"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in registrationUserList"
                  :key="item.id"
                  :label="item.realName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px">
          <!--搜索-->
          <el-button
            size="small" type="primary" @click="enterGetSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            size="small" type="info" @click="resetData"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <el-button
            size="small" type="primary" @click="newCode"
          >{{ $t('GlobalSetObj.add') }}
          </el-button>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'orderNumber'">
            {{ scope.row.orderNumber }}
          </div>
          <div v-else-if="item.prop === 'paymentVoucher'">
            <div v-if="scope.row[item.prop] === 1" style="color: #409eff">
              {{ $t('customerManagements.approved') }}
            </div>
            <div v-else-if="scope.row[item.prop] === 2" style="color: #f00">
              {{ $t('orderCenterCont.ReviewFailed') }}
            </div>
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-around; align-items: center">
            <el-tooltip
              v-if="scope.row.showEdit"
              :content="$t('GlobalSetObj.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-edit textOperator" @click="newCode(scope.row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="queryForm.pageNumber"
      :page-size.sync="queryForm.pageSize"
      :page-sizes="[10, 50, 100, 200, 400]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 20px 0; text-align: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!--  生成邀请码  -->
    <newDrawer
      ref="newCodeDialogRef"
      :position-list="positionList"
      :transfer-list="TransferList"
      @invoke-search="enterGetSearch"
    />
  </div>
</template>

<script>
import { headerList } from '@/views/basicData/employeesNumber/tableHeadListData';
import dayjs from 'dayjs';
import { apiStaffRegistrationPage } from '@/api/newExpressAPI/userModule';
import newDrawer from '@/views/basicData/employeesNumber/component/newAdd.vue';
import { getSiteTransfer } from '@/api/orderApi';
import { queryRealName } from '@/api/lanshou';
import { positionList, positionListObj } from '@/utils/enumData';

export default {
  name: 'EmployeesNumber',
  components: {
    newDrawer
  },
  data() {
    return {
      // 是否格式化成巴西时间
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      isTormat: false,
      timeValue: [],
      tableHeaderList: headerList,
      tableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          timeType: 1, // 时间类型 1 失效时间 2 资料提交审核时间 3 最新处理时间
          position: null, // 岗位（1：揽收、2：分拣、3：运输）
          departmentIds: [], // 转运中心ID
          registrationUser: null // 登记人ID
        }
      },
      TransferList: [],
      registrationUserList: [],
      // 勾选表格数据
      selectionList: [],
      DetailId: 0,
      detailDialog: false,
      detailDialogObj: {},
      keyChange: '',
      timeTypeList: [
        { value: 1, label: this.$t('home.onDutyDate') },
        { value: 2, label: this.$t('collectionCenter.RegistrationT') }
      ],
      positionList: positionList
    };
  },
  computed: {
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  mounted() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.getSiteTransfer();
    this.getRegistrationUserList();
  },
  methods: {
    // 点击生成邀请码
    newCode(row) {
      this.$refs.newCodeDialogRef.openCodeDialog(row);
    },
    // 勾选
    handleSelectionChange(data) {
      this.selectionList = data;
    },
    // 搜索
    getSearch() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {}
      };
      data.params = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.startTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        if (!this.queryForm.params.searchNumberStr) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      apiStaffRegistrationPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            if (item.position) {
              item.positionName = positionListObj[item.position];
            }
            if (item.workDate) {
              item.workDate1 = item.workDate + ' 00:00:00';
              item.workDate1 = dayjs(item.workDate1).format('YYYY-MM-DD HH:mm:ss');
              item.showEdit = true;
              const now = dayjs();
              if (now.isBefore(item.workDate1)) {
                item.showEdit = true;
              } else {
                item.showEdit = false;
              }
            }
          });
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const today = dayjs();
      const firstDay = today.startOf('weeks').format('YYYY-MM-DD');
      const lastDay = today.endOf('weeks').format('YYYY-MM-DD');

      this.timeValue = [firstDay + ' 00:00:00', lastDay + ' 23:59:59'];
    },
    resetData() {
      this.getTimer();
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          timeType: 1, // 时间类型 1 失效时间 2 资料提交审核时间 3 最新处理时间
          position: null, // 岗位（1：揽收、2：分拣、3：运输）
          departmentIds: [], // 转运中心ID
          registrationUser: null // 登记人ID
        }
      };
      this.getSearch();
    },
    enterGetSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    getSiteTransfer() {
      getSiteTransfer().then((res) => {
        if (res.code === 200) {
          this.TransferList = res.data;
        }
      });
    },
    getRegistrationUserList(name) {
      const nameVal = name || '';
      queryRealName(nameVal)
        .then((res) => {
          if (res.code === 200) {
            this.registrationUserList = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}

.searchBox >>> .selectClass .el-input__inner {
  font-weight: 700 !important;
}

.textOperator {
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
}
</style>
